import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { ListItemContainer, ListLeft, ListImageContainer, ListImage, ItemInformationContainer, ListRight } from './ListItem.styles.js';
import { ProductHeader, EProductHeader } from '../ProductHeader/ProductHeader.js';
import { EPriceSize, EPriceVariant } from '../PriceTag/PriceTag.types.js';
import { PriceStripe } from '../PriceStripe/PriceStripe.js';
var EListItemAlignment;

(function (EListItemAlignment) {
  EListItemAlignment["CENTER"] = "center";
  EListItemAlignment["TOP"] = "flex-start";
})(EListItemAlignment || (EListItemAlignment = {}));

var ListItem = function ListItem(_a) {
  var _b = _a.alignment,
      alignment = _b === void 0 ? EListItemAlignment.CENTER : _b,
      children = _a.children,
      fallBackImage = _a.fallBackImage,
      imageAutoHeight = _a.imageAutoHeight,
      item = _a.item,
      isSmall = _a.isSmall,
      _c = _a.loading,
      loading = _c === void 0 ? false : _c,
      _d = _a.showPriceStripe,
      showPriceStripe = _d === void 0 ? false : _d,
      smallSkeleton = _a.smallSkeleton;
  return React.createElement(ListItemContainer, null, React.createElement(ListLeft, {
    alignment: alignment
  }, React.createElement(ListImageContainer, {
    isSmall: isSmall
  }, React.createElement(ListImage, {
    autoHeight: imageAutoHeight,
    src: item === null || item === void 0 ? void 0 : item.image,
    alt: item === null || item === void 0 ? void 0 : item.name,
    isSmall: isSmall,
    onError: function onError(e) {
      if (fallBackImage) {
        var target = e.target;

        if (!target.dataset.fallback) {
          target.dataset.fallback = 'true';
          target.onerror = null;
          target.src = fallBackImage;
        }
      }
    }
  })), React.createElement(ItemInformationContainer, {
    alignment: alignment
  }, loading ? React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    height: 15,
    width: smallSkeleton ? 150 : 250
  }), React.createElement(Skeleton, {
    height: 12,
    width: smallSkeleton ? 100 : 200
  })) : React.createElement(React.Fragment, null, showPriceStripe && React.createElement(PriceStripe, {
    size: EPriceSize.SMALL,
    variant: EPriceVariant.PRIO
  }), React.createElement(ProductHeader, {
    location: EProductHeader.LIST_ITEM,
    title: item === null || item === void 0 ? void 0 : item.name,
    subTitle: item === null || item === void 0 ? void 0 : item.description
  })), (item === null || item === void 0 ? void 0 : item.secondaryDescription) && item.secondaryDescription)), children && React.createElement(ListRight, {
    alignment: alignment
  }, children));
};

export { EListItemAlignment, ListItem };